import React from "react";
import { Box } from "@mui/material";

interface IProps {
  isActive: boolean;
}
const StatusIcons = ({ isActive }: IProps): React.ReactElement => {
  return isActive ? <Box color="red">✘</Box> : <Box color="red">✔</Box>;
};

export default StatusIcons;
